import {defineStore} from 'pinia';
import {ModuleEquipmentInventoryItem} from '../../moduleConst';
import {BaseDictionaryStore} from '@/stores/baseDictionaryStore.js';
import InventoryItemAPI from '@/apis/di/equipmentInventoryItemListAPI';
import StockAPI from '@/apis/di/stockAPI';
const InventoryItemStore = new BaseDictionaryStore(InventoryItemAPI);
const StockStore = new BaseDictionaryStore(StockAPI);
export const useEquipmentInventoryItemStore = defineStore(ModuleEquipmentInventoryItem, {
  state: () => ({
    ...InventoryItemStore.state,
    _config: {
      key: 'inventory_item_id',
      code: 'inventory_item_code',
      name: 'inventory_item_name',
      table: 'di_inventory_item',
      moduleName: 'Công cụ dụng cụ',
      quickFollow: 'active',
      defaultSort: 'inventory_item_code',
    },
    moduleName: 'inventoryItem',
  }),
  actions: {
    ...InventoryItemStore.action,
    GetStock: () => {
      return StockStore.state.items;
    },

    /**
     * Lấy ra danh sách CCDC đã ghi tăng và số lượng ghi tăng >0 tính đến thời điểm hiện tại
     * ntban - 5.7.2023
     * @param {*} param
     * @returns
     */
    async getInventoryForDecrement(posted_date) {
      const me = this;
      let res = null;
      try {
        me.loading = true;
        res = await InventoryItemAPI.getInventoryForDecrement(posted_date || {});
      } finally {
        me.loading = false;
      }
      return res;
    },
  },
  getters: {
    ...InventoryItemStore.getters,
  },
});
